<template>
  <div
    class="dialogbox"
    id="dialogmain"
    @click.stop="closeit($event)"
    v-if="isshow"
  >
    <div
      class="dialogcontent"
      style="width: 60%;min-height:60%;background-color:#fff;"
      v-if="datas.colortype!=3&&datas.colortype!=4"
    >
      <span
        class="close_view_mobile el-icon-circle-close"
        @click="closePopup"
      ></span>
      <h2
        class="dialogheader"
        :style="{backgroundColor:datas.colortype==1?'#c32e28':'#1a909e'}"
      >
       {{datas.poptitle}}
      </h2>
      <div style="background-color:#fff;">
        <div style="font-size:0.25rem;padding:0.2rem;text-align:center;">
          {{datas.title}}
        </div>
        <div class="wrapper"
          style="font-size:0.2rem;padding:20px 0.4rem;line-height:1.6;overflow-y: scroll;max-height:6rem;" v-if="datas.content"
        >
          <div  v-html="datas.content">
          </div>
          <ul style="padding-top:15px">
            <li style="margin-bottom:5px;font-size: 0.25rem;" v-if="index!=0">
              上一篇：<span  style="cursor: pointer;color: #16418a;text-decoration: underline;text-decoration-color: #16418a;" @click="changeContent(list[index-1],index-1)">{{ list[index-1].title }}</span>
            </li>
            <li style="font-size: 0.25rem;" v-if="index!=list.length-1">
              下一篇：<span @click="changeContent(list[index+1],index+1)" style="cursor: pointer;color: #16418a;text-decoration: underline;text-decoration-color: #16418a;">{{ list[index+1].title }}</span>
            </li>
          </ul>
        </div>
        <div v-if="datas.data" class="wrapper"
          style="font-size:0.2rem;padding:20px 0.4rem;line-height:1.6;overflow-y: scroll;max-height:6rem;"
        >
          <div v-html="datas.data">
          </div>
          <ul style="padding-top:15px">
            <li style="margin-bottom:5px;font-size: 0.25rem;" v-if="index!=0">
              上一篇：<span  style="cursor: pointer;color: #16418a;text-decoration: underline;text-decoration-color: #16418a;" @click="changeContent(list[index-1],index-1)">{{ list[index-1].title }}</span>
            </li>
            <li style="font-size: 0.25rem;" v-if="index!=list.length-1">
              下一篇：<span @click="changeContent(list[index+1],index+1)" style="cursor: pointer;color: #16418a;text-decoration: underline;text-decoration-color: #16418a;">{{ list[index+1].title }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="dialogcontent"
      style="width:13rem;"
      v-if="datas.colortype==3"
    >
      <div class="popup_content">
        <div class="popup_title">{{datas.poptitle}}</div>
        <div class="content_fix characteristic">
          <dl class="member_popup_info">
            <dt>
              <img
                v-if="datas.head_img"
                :src="datas.head_img"
                alt=""
                width="100"
                height="100"
              />
              <img
                v-if="datas.avatar"
                :src="datas.avatar"
                alt=""
                width="100"
                height="100"
              />
              <p v-if="datas.real_name">{{datas.real_name}}</p>
              <p v-if="datas.name">{{datas.name}}</p>
            </dt>
            <dd>
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                style="table-layout: fixed; "
              >
                <tbody>
                  <tr>
                    <th>性别</th>
                    <td>
                      <span v-if="datas.sex==1">男</span>
                      <span v-if="datas.sex==2">女</span>
                    </td>
                    <th>民族</th>
                    <td>
                      {{datas.nation}}
                    </td>
                  </tr>
                  <tr>
                    <th>学历</th>
                    <td>{{datas.education}}</td>
                    <th>出生年月</th>
                    <td v-if="datas.birthday&&datas.birthday!='0000-00-00'">{{datas.birthday}}</td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <th>工作时间</th>
                    <td>{{datas.workday}}</td>
                    <th>职务</th>
                    <td>{{datas.leader_position}}</td>
                  </tr>
                  <tr>
                    <th v-if="datas.join_party_day">入党时间</th>
                    <td v-if="datas.join_party_day">{{datas.join_party_day}}</td>
                    <th>电话号码</th>
                    <td>{{datas.phone}}</td>
                    <th v-if="!datas.join_party_day"></th>
                    <td v-if="!datas.join_party_day"></td>
                  </tr>
                  <tr v-if="datas.data">
                    <td
                      colspan="4"
                      style="text-align:left;padding-left:5px;"
                    >
                      <span v-if="datas.data">{{datas.data}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </dd>
          </dl>
        </div>
        <s
          class="close"
          id="closebox"
          @click="closeit($event)"
        ></s>
      </div>
    </div>
    <!-- 登录界面 -->
    <div
      class="logincontent"
      v-if="datas.colortype==4"
    >
      <div class="loginimgbox">
        <img
          src="../../../../../assets/images/ktscreen/logindh.png"
          alt=""
          srcset=""
        >
      </div>
      <div class="el-form-box">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          label-width="60px"
          :hide-required-asterisk="true"
        >
          <div class="login_form_title">欢迎登陆{{datas.logintitle}}</div>
          <el-form-item
            label="用户名:"
            prop="username"
          >
            <el-input
              ref="username"
              placeholder="请输入账号"
              v-model="loginForm.username"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="密码:"
            prop="password"
          >
            <el-input
              type="password"
              ref="password"
              class="inputBox"
              placeholder="请输入密码"
              v-model="loginForm.password"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            label="验证码:"
            prop="imgcode"
            class="imgcodeBOx"
          >
            <div class="imgcode_box">
              <el-input
                class="inputBox"
                placeholder="请输入验证码"
                v-model="loginForm.imgcode"
                popper-class="my-autocomplete"
              ></el-input>
              <img
                :src="imgcode"
                @click="getImgCode"
              />
            </div>
          </el-form-item>
          <div class="login_password">
            <span @click="clearSession">忘记密码？</span>
          </div>
          <el-form-item label="">
            <el-button
              :loading="loading"
              type="danger"
              class="loginbtn"
              @click.native.prevent="handleLogin"
            >登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import BranchRouter from '@/views/Login/BranchRouter.json'
import CommitteeRouter from '@/views/Login/CommitteeRouter.json'
import MessageBox from '@/components/MessageBox'
import { baseURL } from '@/assets/js/baseURL'
import { $ws } from '@/assets/js/websocket/newsocket'
import Vcode from 'vue-puzzle-vcode'
export default {
  // props: {
  //   isshow: {
  //     type: Boolean,
  //     default: false
  //   },
  //   datas: {
  //     type: Object,
  //     default: {}
  //   }
  // },
  props: ['isshow', 'datas','currentLDIndex','list'],
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能少于6位数字'))
      } else {
        callback()
      }
      const validateImage = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入正确的验证码'))
        } else {
          callback()
        }
      }
    }
    return {
      loginForm: {
        username: '',
        password: '',
        imgcode: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', validator: validateUsername }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ],
        imgcode: [
          // { required: true, trigger: "blur", validator: validateImage },
        ]
      },
      imgcode: '',
      loading: false,
      index: 0 // 特色亮点列表下标
    }
  },
  watch:{
    isshow(n){
      this.index=this.currentLDIndex
    }
  },
  mounted() {
    this.captch()
  },
  methods: {
    closeit(event) {
      //点击位置为阴影处可关闭
      if (
        event.target == document.getElementById('dialogmain') ||
        event.target == document.getElementById('closebox')
      ) {
        this.$emit('changepop', true)
      }
    },
    // 获取验证码图片
    getImgCode() {
      this.captch()
    },
    captch() {
      let url = baseURL
      this.imgcode = url + '/admin/captcha_pro?' + Date.parse(new Date())
      console.log(this.imgcode)
    },
    clearSession() {
      sessionStorage.clear()
      this.RouteGo('ForgotPassword')
    },
    // 检测当前是否是登录状态，如果是登录状态，则直接跳转至home页面
    async checkLogin() {
      const that = this
      const date = new Date()
      const nowTime = date.getTime() / 1000
      // 如果曾经登录过且token未过期,就直接跳转到Home页面
      if (
        localStorage.Token !== undefined &&
        localStorage.expires_time > nowTime
      ) {
        const data = await this.PublicApi('admin/organization/getId')
        // 管理人员身份认证获取
        this.$setSession('ISCOM', data.data.is_com)
        const ISCOM = parseInt(this.$getSession('ISCOM'))
        if (ISCOM === 1) {
          // 1是党委 0是支部
          that.$store.state.HCRoutes = CommitteeRouter
        } else {
          that.$store.state.HCRoutes = BranchRouter
        }

        that.loading = false
        this.$message({
          message: '系统检测到您已登录，自动为您跳转到系统首页',
          type: 'success'
        })
        that.RouteGo('Home')
      } else {
        that.RouteGo('Login')
      }
    },
    /**
     * 登录账号
     */
    handleLogin() {
      const that = this
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 异步形式登录
          this.$store
            .dispatch('user/login', this.loginForm)
            .then(async items => {
              console.log($ws)
              Vue.use($ws)
              $ws.newsocket()
              // 判断是否是顶级党委
              this.$setSession('TOPLEVEL', items.top_level)
              // 判断手机号是否注册
              if (items.is_complete) {
                const data = await this.PublicApi('admin/organization/getId')
                // 管理人员身份认证获取
                this.$setSession('ISCOM', data.data.is_com)
                const ISCOM = parseInt(this.$getSession('ISCOM'))
                if (ISCOM === 1) {
                  // 1是党委 0是支部
                  that.$store.state.HCRoutes = CommitteeRouter
                } else {
                  that.$store.state.HCRoutes = BranchRouter
                }
                let userinfodata = await this.PublicApi(
                  'admin/base/getUserInfo'
                )
                //topid==0   //visit_screen ==1
                if (userinfodata.data.top_id == 0) {
                  that.$router.push({ name: 'Menus' })
                } else if (userinfodata.data.visit_screen == 1) {
                  that.$router.push({ name: 'Menus' })
                } else {
                  that.$router.push({ name: 'Home' })
                }
                this.loading = false
              } else {
                this.$confirm('此账号未绑定手机号！', '提示', {
                  confirmButtonText: '前往绑定',
                  cancelButtonText: '暂不绑定',
                  type: 'warning'
                })
                  .then(() => {
                    // console.log("点击注册了");
                    this.RouteGo('registration')
                  })
                  .catch(async () => {
                    const data = await this.PublicApi(
                      'admin/organization/getId'
                    )
                    // 管理人员身份认证获取
                    this.$setSession('ISCOM', data.data.is_com)
                    const ISCOM = parseInt(this.$getSession('ISCOM'))
                    if (ISCOM === 1) {
                      // 1是党委 0是支部
                      that.$store.state.HCRoutes = CommitteeRouter
                    } else {
                      that.$store.state.HCRoutes = BranchRouter
                    }
                    let userinfodata = await this.PublicApi(
                      'admin/base/getUserInfo'
                    )
                    //topid==0   //visit_screen ==1
                    if (userinfodata.data.top_id == 0) {
                      that.$router.push({ name: 'Menus' })
                    } else if (userinfodata.data.visit_screen == 1) {
                      that.$router.push({ name: 'Menus' })
                    } else {
                      that.$router.push({ name: 'Home' })
                    }
                    this.loading = false
                  })
              }
            })
            .catch(data => {
              this.$message.error(data.msg)
              this.loading = false
            })
        } else {
          console.log('登录失败')
          return false
        }
      })
    },
    closePopup() {
      this.$parent.isshowpop = false
    },
    // 切换分页
    changeContent(item,index){
      this.index=index
      this.$emit('changeContent',item)
    },
  }
}
</script>
<style lang="less" scoped>
.dialogbox {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
}

.dialogheader {
  height: 0.6rem;
  line-height: 0.6rem;
  color: #fff;
  text-align: center;
  font-size: 0.3rem;
}

.dialogcontent {
  display: flex;
  flex-direction: column;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
}

.logincontent {
  width: 7rem;
  display: flex;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
  border-radius: 15px;
  background-color: #fff;
}

.characteristic {
  padding: 0 20px 20px 20px;

  h2 {
    font-size: 0.4rem;
  }

  .time {
    text-align: right;
    padding: 10px 30px;
    font-size: 0.4rem;
  }

  .content {
    text-align: left;
    font-size: 0.4rem;
    line-height: 36px;
    height: 700px;
    overflow: auto;
  }
}

.close {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 50px;
  height: 50px;
  background: url('../../../../../assets/images/ktscreen/close.png') no-repeat
    center center;
  cursor: pointer;
}

.popup_content {
  width: 100%;
  height: 100%;
  background: #00c1d8;
  border-radius: 15px;
}

.member_popup_info {
  overflow: hidden;
  padding: 0px 20px 20px 20px;
  display: flex;

  dt {
    /* width: 328px; */

    img {
      width: 200px;
      height: 280px;
      background: #fff;
      display: block;
      margin: 0 auto;
    }

    p {
      color: #fff;
      text-align: center;
      background: url('../../../../../assets/images/ktscreen/index_12.png')
        no-repeat -8px -4px;
      width: 328px;
      height: 92px;
      font-size: 0.3rem;
      line-height: 72px;
      font-weight: bold;
    }
  }

  dd {
    /* float: left; */
    color: #fff;
    padding: 0 20px;
    /* width: 638px; */
    margin-left: 10px;
    flex: 1;

    table {
      td,
      th {
        border: 1px #fff solid;
        height: 76px;
        /* text-indent: 1em; */
        font-size: 0.2rem;
      }

      th {
        font-weight: bold;
        text-align: left;
        padding-left: 0.2rem;
      }

      td {
        vertical-align: middle;
        text-align: center;
      }
    }
  }
}

.popup_title {
  color: #fff !important;
  margin: 0;
  height: 70px;
  line-height: 70px;
  font-size: 0.3rem;
  -webkit-text-fill-color: #fff;
  text-align: center;
}

.login_form_box {
  width: 85%;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, 0);
}

.el-form-box {
  background-color: #fff;
  padding: 22px 26px;
  /* min-width: 300px;
    max-width: 400px; */
  box-sizing: border-box;
  flex: 1;
  border-radius: 15px;
}

.imgcode_box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  > img {
    width: 45%;
    height: 100%;
  }

  .inputBox {
    width: 45%;
    height: 100%;
    border: 0;
    padding: 0;
  }
}

.login_form_title {
  color: #ee2727;
  padding: 0px 0 20px 0px;
  /* border-bottom: 1px solid #f2f2f2; */
  font-size: 21px;
  font-weight: 600;
}

// 表单按钮修改样式
#logins {
  .el-form-item__label {
    padding: 0 14px 0 0;
  }

  .el-button--danger {
    background-color: #ee2727;
    border-color: #ee2727;
  }

  .el-button {
    font-size: 16px;
    letter-spacing: 2px;
  }

  .el-form-item {
    margin-top: 40px;
  }
}

.loginbtn {
  width: 100%;
  margin-top: 1%;
  margin-left: -30px;
}

/*
    登录忘记密码
  */
.login_password {
  color: #ee2727;
  padding: 0px 0 7px 10px;
  /* border-bottom: 1px solid #f2f2f2; */
  font-size: 12px;
  font-weight: 600;
  text-align: right;

  /*步骤条样式修改*/
  .el-steps.el-steps--horizontal
    /deep/
    .el-step.is-horizontal.is-center
    /deep/
    .el-step__head.is-finish {
    color: #eb6f67 !important;
    border-color: #eb6f67 !important;
  }

  .el-steps.el-steps--horizontal
    /deep/
    .el-step.is-horizontal.is-center
    /deep/
    .el-step__title.is-finish {
    color: #666666;
  }

  .el-steps.el-steps--horizontal
    /deep/
    .el-step.is-horizontal.is-center
    /deep/.el-step__description.is-finish {
    color: #999999;
  }
}

.loginimgbox {
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 2.18rem;
    height: 2.12rem;
  }
}

.close_view_mobile {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 24px;
  color: #fff;
}
.wrapper::-webkit-scrollbar{display: none}
</style>



// WEBPACK FOOTER //
// src/views/Works/platformHome/components/WDialog/index.vue